import { useState } from "react";
import "./Notifications.scss";
import { Tabs, Badge } from "antd";
import NotificationList from "./notificationList/NotificationList";
import { ClearIconDrawer } from "../../../../assets/icons";
import { useSelector } from "react-redux";

const { TabPane } = Tabs;

function Notifications({ handleCancel }) {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [activeKey, setActiveKey] = useState(1);
  const [badgeCount, setBadgeCount] = useState({
    All: 0,
    Hidden: 0,
    Relevant: 0,
    Mentioned: 0,
  });
  const [activeFilter, setActiveFilter] = useState(null);

  function callbackActiveKey(key) {
    setActiveKey(key);
  }

  const processActiveFilter = (filterID) => {
    if (filterID !== activeFilter) {
      setActiveFilter(filterID);
    } else {
      setActiveFilter(null);
    }
  };

  const countNotifs = (notifs) => {
    // console.log(notifs);
    if (!!notifs) {
      setBadgeCount(notifs);
    }
  };

  const notifProps = {
    activeFilter,
    processActiveFilter,
    activeKey,
    countNotifs,
  };

  return (
    <div className="dashboard-notifications">
      {/* <div className="notifications-title">
        <span className="title">Njoftime</span>
      </div> */}

      <Tabs
        animated={{ inkBar: true, tabPane: false }}
        tabPosition={"top"}
        defaultActiveKey={1}
        onChange={() => callbackActiveKey}
        className="notification-tabs"
        tabBarExtraContent={
          <div className="extraContentContainer">
            <ClearIconDrawer
              fill={isDarkMode ? "#e6e6e6" : "#1d3445"}
              style={{ cursor: "pointer" }}
              onClick={() => handleCancel()}
            />

            <div className="extraContentTitle">Njoftimet</div>
          </div>
        }
      >
        {notifsPages.map((n) => (
          <TabPane
            tab={
              <Badge
                key={n.id}
                style={{ position: "relative" }}
                count={badgeCount[n.type]}
              >
                {n.name}
              </Badge>
            }
            key={n.id}
          >
            {" "}
            <NotificationList
              handleCancel={handleCancel}
              notifsType={n.type}
              {...notifProps}
            />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
}

const notifsPages = [
  { id: 1, name: "Të gjitha", type: "All" },
  // { id: 2, name: "Relevante", type: "Relevant" },
  { id: 3, name: "Të Fshehura", type: "Hidden" },
  // { id: 4, name: "Caktuar Mua", type: "Mentioned" },
];
export default Notifications;
